import { Analytics, AnalyticsRecord } from '..'

const consoleAnalytics: Analytics = {
  dataLayer: (record: AnalyticsRecord): void => console.log(record),
}

export default consoleAnalytics
